export const WEEK_DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado']
export const WEEK_DAYS_SHORT = ['D', 'L', 'M', 'M', 'J', 'V', 'S']
export const APPOINTMENT_DATE_FORMAT = 'DD/MM/YYYY'